module.exports = __webpack_public_path__ + "assets/img/36@3x.b0a8cc85.png";